module.exports = __webpack_public_path__ + "media/images/fanclub/merit-chara-04@2x-e5457ad5dd3b1e8ed8757bd80dd696fd.png";